
import {
    NEW_USUARIO_WHITE_LABEL_SUCCESS,
    TABLE_USUARIO_WHITE_LABEL_PENDING,
    TABLE_USUARIO_WHITE_LABEL_SUCCESS,
    TABLE_USUARIO_WHITE_LABEL_FAILURE,
    LIST_USUARIO_WHITE_LABEL_PENDING,
    LIST_USUARIO_WHITE_LABEL_SUCCESS,
    LIST_USUARIO_WHITE_LABEL_FAILURE,
    DELETE_USUARIO_WHITE_LABEL_PENDING,
    DELETE_USUARIO_WHITE_LABEL_SUCCESS,
    DELETE_USUARIO_WHITE_LABEL_FAILURE,
    CREATE_USUARIO_WHITE_LABEL_PENDING,
    CREATE_USUARIO_WHITE_LABEL_SUCCESS,
    CREATE_USUARIO_WHITE_LABEL_FAILURE,
    FIND_USUARIO_WHITE_LABEL_PENDING,
    FIND_USUARIO_WHITE_LABEL_SUCCESS,
    FIND_USUARIO_WHITE_LABEL_FAILURE,
    ACTIVE_INACTIVE_USUARIO_WHITE_LABEL_FAILURE,
    ACTIVE_INACTIVE_USUARIO_WHITE_LABEL_SUCCESS,
    ACTIVE_INACTIVE_USUARIO_WHITE_LABEL_PENDING,
} from './actionTypes';


const initialState = { list: null, loading: false }


function usuarioWhiteLabelReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_USUARIO_WHITE_LABEL_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_USUARIO_WHITE_LABEL_PENDING:
        case DELETE_USUARIO_WHITE_LABEL_PENDING:
        case CREATE_USUARIO_WHITE_LABEL_PENDING:
        case TABLE_USUARIO_WHITE_LABEL_PENDING:
        case FIND_USUARIO_WHITE_LABEL_PENDING:
        case ACTIVE_INACTIVE_USUARIO_WHITE_LABEL_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_USUARIO_WHITE_LABEL_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_USUARIO_WHITE_LABEL_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_USUARIO_WHITE_LABEL_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_USUARIO_WHITE_LABEL_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_USUARIO_WHITE_LABEL_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_USUARIO_WHITE_LABEL_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_USUARIO_WHITE_LABEL_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_USUARIO_WHITE_LABEL_FAILURE:
        case CREATE_USUARIO_WHITE_LABEL_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_USUARIO_WHITE_LABEL_FAILURE:
        case ACTIVE_INACTIVE_USUARIO_WHITE_LABEL_FAILURE:
        case ACTIVE_INACTIVE_USUARIO_WHITE_LABEL_SUCCESS:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { usuarioWhiteLabelReducer };